/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Background from '../../../assets/Images/png/bg-new-password.svg';
import IconSuccess from '../newpassword/Icon';
import { useTranslation } from 'react-i18next';

export default function SuccessForm() {
    const location = useLocation();
    const navigate = useNavigate();
    const status = location?.state?.status;
    const { t } = useTranslation();

    useEffect(() => {
        if (status !== 'success') {
            navigate('/');
        }
    }, []);

    return (
        <div
            className="h-screen w-full bg-cover bg-fixed bg-no-repeat bg-center relative"
            style={{
                backgroundImage: `url(${Background})`,
            }}
        >
            <div className="flex justify-center items-center w-full h-screen">
                <div className="w-sm m-auto rounded-lg pb-12">
                    <div className="text-center">
                        <IconSuccess />
                    </div>
                    <div className="flex justify-center mb-12">
                        <div>
                            <div className="pt-6 font-medium text-3xl text-center">
                                {t('passwordPage.SuccessfullyChangedPassword')}
                            </div>
                            <div className="text-sm text-[#65707A]">
                                {t(
                                    'passwordPage.YourPasswordWasChangedSuccessfully'
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="text-center">
                        <Button
                            className="px-12"
                            type="primary"
                            size="large"
                            onClick={() => {
                                navigate('/login');
                            }}
                        >
                            {t('Login')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
